import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./Home.module.scss";
import cardListStyles from "../../library/component/CardList/CardList.module.scss";

import { ModernSlider } from "../../library/component";
import localesKeys from "../../locales/localesKeys.json";
import { CardList, EaseCards } from "../../library/component/CardList";
import Loader from "../../library/common/Loader/Loader";
import { getBookAll, getBlogAll, getTirthAll } from "../../services";
import { getCollaborators } from "../../services/apis/users";
import { getTirthStates } from "../../services/apis/tirth";
import MetaTag from "../../library/meta";

const Home = () => {
  const { t } = useTranslation();
  const [featuredBooks, setFeaturedBooks] = useState([]);
  const [featuredBlogs, setFeaturedBlogs] = useState([]);
  const [featuredTirth, setFeaturedTirth] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [states, setStates] = useState([]);
  const [loader, setLoader] = useState(false);

  const fetchBooks = async () => {
    setLoader(true);
    try {
      const res = await getBookAll({ filters: { featured: true } });
      setFeaturedBooks(
        res?.success && res?.data?.list?.length ? res?.data?.list : []
      );
    } catch (error) {
      setFeaturedBooks([]);
    } finally {
      setLoader(false);
    }
  };

  const fetchBlogs = async () => {
    setLoader(true);
    try {
      const res = await getBlogAll({ filters: { featured: true } });
      setFeaturedBlogs(
        res?.success && res?.data?.list?.length ? res.data.list : []
      );
    } catch (error) {
      setFeaturedBlogs([]);
    } finally {
      setLoader(false);
    }
  };

  const fetchTirth = async () => {
    setLoader(true);
    try {
      const res = await getTirthAll({ filters: { featured: true } });
      setFeaturedTirth(
        res?.success && res?.data?.list?.length ? res.data.list : []
      );
    } catch (error) {
      setFeaturedTirth([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchBooks();
    fetchBlogs();
    fetchTirth();
    getCollaborators().then((res) => {
      setCollaborators(res?.data || []);
    });

    getTirthStates()
      .then((res) => {
        if (res?.success) {
          let data = res?.data?.map((item) => ({
            title: item?.label,
            imageUrl: item?.imageUrl || "",
            id: item?.value,
          }));

          setStates(data || []);
        }
      })
      .catch(() => setStates([]));
  }, []);

  return (
    <main className={styles.homeContainer}>
      <MetaTag
        title={t(localesKeys.HOME_TITLE)}
        shortDescription={t(localesKeys.HOME_DESCRIPTION)}
      />
      {loader ? <Loader /> : null}

      <ModernSlider path="home" />

      {featuredBooks?.length > 0 && (
        <CardList
          title={t(localesKeys.FEATURED_BOOK_LIST)}
          list={featuredBooks}
          linkDetails={{ name: t(localesKeys.VIEW_ALL), to: "/granth" }}
          parentPath={"granth"}
          type="granth"
        />
      )}

      {states?.length > 0 && (
        <EaseCards
          type={"rectangularEase"}
          title="Regional Tirth"
          list={states}
          showArrows
          customStyles={{ containerStyle: cardListStyles.containerBg }}
        />
      )}

      {featuredBlogs && featuredBlogs?.length > 0 && (
        <CardList
          type="blog"
          title={t(localesKeys.FEATURED_BLOG_LIST)}
          list={featuredBlogs}
          linkDetails={{ name: t(localesKeys.VIEW_ALL), to: "/blogs" }}
          parentPath={"blogs"}
        />
      )}

      {collaborators?.length > 0 && (
        <EaseCards
          type={"circularEase"}
          title="Collaborators"
          list={collaborators}
          customStyles={{ containerStyle: cardListStyles.containerBg }}
        />
      )}

      {featuredTirth?.length > 0 && (
        <CardList
          type="tirth"
          title={t(localesKeys.FEATURED_TIRTH_LIST)}
          list={featuredTirth}
          linkDetails={{ name: t(localesKeys.VIEW_ALL), to: "/tirth" }}
          parentPath={"tirth"}
        />
      )}
    </main>
  );
};

export default Home;
